/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 13:40:46
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Industry\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Industry() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const industryCenter = t("solution_archives.archives2", {
    returnObjects: true,
  });
  return (
    <div className="industry_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{industryCenter.til}</div>
          <span>{industryCenter.detail}</span>
        </div>
      </div>
      <div className="industry_con">
        {industryCenter.contentList.map((item0, index0) => {
          return (
            <div
              className="industry_li"
              key={index0}
              onMouseEnter={()=>{
                setActiveIndex(index0)}}
              onMouseLeave={()=>setActiveIndex(null)}
            >
              <img className="industry_li_img" src={item0.imgUrl} alt="" />
              <div className="industry_li_body">
                <div className="industry_li_til">
                  <img
                    src={activeIndex === index0 ? item0.icon2 : item0.icon1}
                    alt=""
                  />
                  {item0.tit}
                </div>
                <div className={`industry_li_con ${language === "zh" ? "" : "industry_li_con_en"}`}>{item0.detail}</div>
                <ul className="industry_li_card">
                  {item0.list.map((item1, index1) => {
                    return <li key={index0 + index1}>{item1}</li>;
                  })}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Industry;
